<template>
  <el-dialog
    v-model="dialogFormVisible"
    :title="title"
    width="500px"
    @close="close"
  >
    <el-form ref="form" label-width="80px" :model="form" :rules="rules">
      <el-form-item v-if="!branchId && !isEdit" label="门店" prop="branchId">
        <el-select v-model="form.branchId" clearable placeholder="请选择门店">
          <el-option
            v-for="item in branchs"
            :key="item.branchId"
            :label="`${item.title}`"
            :value="item.branchId"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="!branchId && isEdit" label="门店" prop="branchId">
        {{ branchTitle }}
      </el-form-item>
      <el-form-item label="标题" prop="title">
        <el-input v-model="form.title" />
      </el-form-item>
      <el-form-item label="备注" prop="text">
        <el-input v-model.trim="form.text" />
      </el-form-item>
      <el-form-item label="排序" prop="order">
        <el-input-number v-model="form.order" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
  import { addDepartment, editDepartment, getAllBranchs } from '@/api/branch'
  import storejs from 'store'

  export default {
    name: 'BranchDepartmentEdit',
    emits: ['fetch-data'],
    data() {
      return {
        branchs: [],
        branchTitle: '',
        branchId: '',
        isEdit: false,
        form: {
          title: '',
          text: '',
          order: 0,
          branchId: '',
        },
        rules: {
          title: [{ required: true, trigger: 'blur', message: '请填写标题' }],
          text: [],
          branchId: [],
          order: [],
        },
        title: '',
        dialogFormVisible: false,
      }
    },
    mounted() {
      const me = storejs.get('me')
      this.branchId = me.extra.branchId || ''
    },
    methods: {
      async getBranchs() {
        this.branchs = await getAllBranchs()
      },
      showEdit(row) {
        if (!row) {
          this.title = '新增部门'
          this.branchTitle = ''
          this.isEdit = false
        } else {
          this.title = '修改部门'
          this.branchTitle = row.branch.title
          this.isEdit = true
          this.form = Object.assign(
            {},
            {
              departmentId: row.departmentId,
              title: row.title,
              text: row.basic.text,
              order: row.basic.order,
            }
          )
        }
        this.dialogFormVisible = true
        this.getBranchs()
      },
      close() {
        this.$refs['form'].resetFields()
        this.form = this.$options.data().form
        this.dialogFormVisible = false
      },
      save() {
        this.$refs['form'].validate(async (valid) => {
          if (valid) {
            await (this.form.departmentId
              ? editDepartment(this.form)
              : addDepartment(this.form))
            this.$baseMessage(
              this.form.departmentId ? '修改部门成功' : '新增部门成功',
              'success',
              false,
              'vab-hey-message-success'
            )
            this.$emit('fetch-data')
            this.close()
          } else {
            return false
          }
        })
      },
    },
  }
</script>
